export default __webpack_public_path__ + "media/src/shared/images/logo/sns/one-859af6d146261534c08f495994db2a65.png";